import {Page, SubPage} from '@entities/left-panel/left-panel.interface';
import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {AppState} from '@store';
import {LeftPanelState} from '@store/left-panel/reducer';
import {createStateSelector} from 'amc-common-components';
import {MenuItemIdOption} from './entities/left-panel.interfaces';

/**
 * Create feature selectors with a LeftPanelState (feature state).
 */
const getLeftPanelState = createFeatureSelector<LeftPanelState>('leftPanel');
/** Auxiliary 'createLeftPanelSelector' variable.' */
const createLeftPanelSelector = <K extends keyof AppState['leftPanel'] = keyof AppState['leftPanel']>(
	prop: K
): MemoizedSelector<AppState, AppState['leftPanel'][K]> => createStateSelector(getLeftPanelState, prop);
/** Auxiliary 'getPages' variable.' */
const getPages = createLeftPanelSelector('pages');
/**
 * Create a selector for the Menu Item Id Options of the LeftPanelState.
 */
const getMenuItemIdOptions = createSelector(getPages, (pages: Page[]): MenuItemIdOption[] => {
	const productPage = pages.filter((page: Page) => page.id === 'products')[0];
	const menuItemIdOptions =
		productPage.subPages?.map(
			(subPage: SubPage): MenuItemIdOption => ({
				name: subPage.name,
				value: [subPage.menuItemID],
				displayValueKey: 'name',
			})
		) || [];
	menuItemIdOptions.unshift({
		name: 'ALL',
		value: [],
		displayValueKey: 'name',
	});
	return menuItemIdOptions;
});

/** Auxiliary 'leftPanelSelector' variable.' */
export const leftPanelSelector = {
	pagesLoadingStatus: createLeftPanelSelector('pagesLoadingStatus'),
	pages: createLeftPanelSelector('pages'),
	activePage: createLeftPanelSelector('activePage'),
	activeSubPage: createLeftPanelSelector('activeSubPage'),
	activeVendor: createLeftPanelSelector('activeVendor'),
	hideLeftPanel: createLeftPanelSelector('hideLeftPanel'),
	menuItemIdOptions: getMenuItemIdOptions,
};
